export default {
  name: "姓名",
  tel: "電話",
  save: "保存",
  confirm: "確定",
  cancel: "取消",
  delete: "刪除",
  complete: "完成",
  loading: "加載中...",
  telEmpty: "請填寫電話",
  nameEmpty: "請填寫姓名",
  nameInvalid: "請輸入正確的姓名",
  confirmDelete: "確定要刪除嗎",
  telInvalid: "請輸入正確的手機號",
  SelectYearMonthDay: "選擇年、月、日",
  vanCalendar: {
    end: "結束",
    start: "開始",
    title: "日期選擇",
    confirm: "確定",
    startEnd: "開始/結束",
    weekdays: ["日", "一", "二", "三", "四", "五", "六"],
    monthTitle: "(year, month) => ${year}年${month}月",
    rangePrompt: "(maxRange) => 選擇天數不能超過 ${maxRange} 天",
  },
  vanCascader: {
    select: "請選擇",
  },
  vanContactCard: {
    addText: "添加聯絡人",
  },
  vanContactList: {
    addText: "新增聯絡人",
  },
  vanPagination: {
    prev: "上一頁",
    next: "下一頁",
  },
  vanPullRefresh: {
    pulling: "下拉即可刷新...",
    loosing: "釋放即可刷新...",
  },
  vanSubmitBar: {
    label: "合計：",
  },
  vanCoupon: {
    unlimited: "無使用門檻",
    discount: "(discount) => ${discount}折",
    condition: "(condition) => 滿${condition}元可用",
  },
  vanCouponCell: {
    title: "優惠券",
    tips: "暫無可用",
    count: "(count) => ${count}張可用",
  },
  vanCouponList: {
    empty: "暫無優惠券",
    exchange: "兌換",
    close: "不使用優惠券",
    enable: "可用",
    disabled: "不可用",
    placeholder: "請輸入優惠碼",
  },
  vanAddressEdit: {
    area: "地區",
    postal: "郵政編碼",
    areaEmpty: "請選擇地區",
    addressEmpty: "請填寫詳細地址",
    postalEmpty: "郵政編碼格式不正確",
    defaultAddress: "設為默認收貨地址",
    telPlaceholder: "收貨人手機號",
    namePlaceholder: "收貨人姓名",
    areaPlaceholder: "選擇省 / 市 / 區",
  },
  vanAddressEditDetail: {
    label: "詳細地址",
    placeholder: "街道門牌、樓層房間號等資訊",
  },
  vanAddressList: {
    add: "新增地址",
  },

  realName: "姓名",
  idCard: "身份证",

  unionManagement: {
    GuildRegistration: "公會入駐",
    GuildSettlementWelcomeLine1: "歡迎來到",
    GuildSettlementWelcomeLine2: "Rain Chat 公會",
    GuildSettlementFormBanner: "請填寫加入公會信息",
    ApplicantID: "申請人ID",
    GuildName: "公會名稱",
    PleaseGuildName: "請輸入公會名稱",
    PleaseGuildID: "請輸入公會ID",
    PleaseInformation: "請輸入你的聯繫方式",
    PlatformsWith: "合作過的平台",
    ListOfplatforms: "列舉合作過的平台",
    GuildSize: "公會規模",
    EstimatedNumber: "預計公會主播人數",
    Notes: "注:可聯繫公會長或公會成員獲取公會ID",
    Submit: "提交",
    SubmitSuccess: "提交成功",
    MyGuild: "我的公會",
    VoiceHallOnboarding: "語音廳入駐",
    WelcomeRainChatVoice: "Welcome to Rain Chat Voice",
    VoiceHallJoinFormBanner: "請填寫加入廳信息",
    VoiceHallName: "語音公會名稱",
    PleaseVoiceHallName: "請輸入語音公會名稱",
    VoiceHallRealName: "真實姓名",
    PleaseVoiceHallRealName: "請輸入真實姓名",
    WhatsApp: "WhatsApp",
    PleaseContactInfo: "請輸入你的聯繫方式",
    PlatformsCollaborated: "合作過的平台",
    ListPlatformsCollaborated: "列舉合作過的平台",
    VoiceHallScale: "語音公會規模",
    EstimatedAnchors: "預計語音廳主播人數",
    CertificationType: "認證類型",
    VoiceHall: "語音廳",
    VoiceGuild: "語音公會",
    HostName: "主播名稱",
    GuildJoinDate: "加入公會時間",
    TotalMembers: "公會總人數",
    TotalPeople: "總人數",
    RoomNicknameLabel: "房間暱稱",
    DataDetails: "數據詳情",
    PleaseHostID: "請輸入主播ID",
    Search: "搜索",
    KickOut: "踢出",
    NoData: "暫無數據",

    InformationData: "信息數據",
    Name: "姓名",
    PleaseID: "請確保與證件上的姓名一致",
    IdentityCard: "身份證",
    YourIDnumber: "您的身份證號碼",
    IDPhoto: "身份證照片",
    PleasePhoto: "請上傳您的身份證照片",
    FrontofID: "身份證正面",
    BackofID: "身份證反面",
    NotePlease:
      "注：請上傳您手持證件的照片，要求面部清晰无遮挡，證件照片及號碼需清晰可見",
    Country: "國家",
    SelectCountryorRegion: "選擇國家/地區",
    BankName: "銀行名稱",
    Pleasebankname: "請填寫開戶銀行名稱",
    BankCardNumber: "帳號號碼",
    Pleasebankcardnumber: "請填寫您的銀行卡號碼",
    BankCardHolder: "銀行卡持有人的姓名",
    Pleasebankcardholder: "請填寫銀行卡持有人的姓名",
    PhoneNumber: "手機號",
    Enterphonenumber: "輸入正確的手機號碼",
    Notebankaccount: "注：請輸入銀行預留的手機號碼。",
    WhatsAppContactInformation: "WhatsApp 聯繫方式",
    Pleaseownnumber: "請務必填寫本人的手機號碼。",
    Notecollaborationmatters:
      "注：公會提供的 WhatsApp 聯繫方式將被視為唯一的合作聯繫方式。",
    Email: "電子郵件",
    Pleaseemailaddress: "請務必填寫本人的電子郵件地址。",
    Notematters: "注：公會提供的電子郵件將被視為唯一的合作聯繫方式。",
    BasicInformationSection: "基本資訊",
    RemarksInformationSection: "備註資訊",

    SpecialGiftDetails: "特效禮物明細",
    CurrentDate: "當前日期",
    GoldCoinTransactions: "金幣流水",
    LiveStreamingDuration: "直播時長",
    GoldBeanEarnings: "金豆收益",
    EffectiveDays: "有效天數",
    WarningCount: "警告次數",
    give: "送",

    pleasewait: "請求中，請稍後...",

    JoinGuild: "加入公會",
    GuildId: "公會ID",
    PlaceholderGuildId: "請輸入公會ID",
    PlaceholderInvitationCode: "請填寫公會邀請碼",

    InvitationCode: "邀請碼",

    noMore: "沒有更多了",

    Recommendation: "推薦人（選填）",
    nightLiveTime: "特殊時間",

    // 公會數據頁面
    GuildTotalData: "公會總數據",
    StatDayUnit: "天",
    GuildIncome: "機構收益",
    AnchorIncome: "主播收益",
    EffectiveLive: "有效開播",
    EffectiveDays: "有效天",
    Income: "收益",
    Duration: "時長",

    // 加入我們頁面
    JoinUs: "加入我們",
    JoinUsWelcome: "Hi,歡迎加入我們～",
    JoinUsSelectMethod: "請選擇加入方式",
    JoinUsVideoGuild: "成為視頻公會",
    JoinUsVideoGuildDesc: "您將會以視頻主播為主",
    JoinUsAudioGuild: "成為語音公會",
    JoinUsAudioGuildDesc: "您將會以語音主播為主",
    JoinUsBack: "返回",
  },

  anchorCenter: {
    todayLiveData: "今日直播數據",
    time: "時間",
    duration: "時長",
    income: "幸運金豆收益",
    giftRecord: "禮物記錄",
    withdraw: "提現",
    tipsUpdate: "注：當日數據每一分鐘更新",
    overallData: "總體數據",
    totalDays: "總天數",
    totalDuration: "總時長",
    totalTurnover: "總幸運金豆",
    totalIncome: "總底薪",
    totalBeans: "總金豆",
    dataListMonth: "數據列表【{month}】",
    filter: "篩選",
    date: "日期",
    turnover: "流水",
    beans: "金豆",
    luckyBeans: "幸運金豆",
    specialBeans: "特效金豆",
    baseSalary: "底薪",
    totalIncomeLabel: "總收入",
    anchorTotalData: "主播總數據",
    anchorNicknamePlaceholder: "主播暱稱",
    myGuild: "我的公會",
    guildNicknamePlaceholder: "公會暱稱",
    anchorDataSection: "主播數據",
    todayDataTitle: "今日數據",
    liveStreamDuration: "直播時長",
    totalGoldBeans: "總金豆",
    nextDayLuckyReward: "次日幸運獎勵",
    specialExtraReward: "特效額外獎勵",
    weekLuckyReward: "本週幸運獎勵",
    estimatedTotalEarnings: "預計總收益",
    grandTotal: "總計",
    zeroTime: "0時0分",
    year: "年",
    month: "月",
  },

  familyMain: {
    anchorList: "主播列表",
    anchorData: "主播數據",
    guildData: "公會數據",
    guildSummaryTitle: "公會匯總",
    guildList: "公會列表",
    micTime: "主播麥時",
    micTimeData: "主播麥時數據",
    beansDetail: "金豆明細",
    beansDetailData: "金豆明細數據",
    withdrawDetail: "提現明細",
    withdrawDetailData: "提現明細數據",
    roomData: "房間數據",
    roomDataData: "房間數據數據",
    distributeBeans: "分配金豆",
    distributeBeansData: "分配金豆數據",
    privateShareStats: "私信/分享統計",
    privateShareStatsData: "私信/分享統計數據",
    roomTurnover: "房間流水",
    roomTurnoverData: "房間流水數據",
    incomeRecord: "收益記錄",
    incomeRecordData: "收益記錄數據",
    knapsackGiftDetail: "背包禮物明細",
    knapsackGiftData: "背包禮物數據",
    roomFilterTitle: "房間篩選",
    roomFilterConfirm: "完成",
    allRooms: "全部房間",
    selectRoom: "選擇房間",
  },
  anchorList: {
    countLabel: "【{count}名主播】",
    searchPlaceholder: "請輸入主播ID",
    search: "搜索",
    joinTimeLabel: "加入時間：",
    noData: "暫無數據",
    nickNameFallback: "主播暱稱",
    invalidUserId: "請輸入數字ID",
  },

  salaryMain: {
    searchPlaceholder: "請輸入主播id搜索",
    dateSelect: "日期選擇",
    byDay: "按天",
    byRange: "按區間",
    searchTime: "搜索時間",
    to: "至",
    dataSummary: "數據匯總",
    totalMicTime: "總麥時",
    totalHeartGiftTurnover: "總幸運金豆",
    totalLuxuryGiftTurnover: "總金豆",
    member: "成員",
    anchorProfile: "主播資料",
    micTime: "麥時",
    heartGiftTurnover: "幸運金豆",
    luxuryGiftTurnover: "總金豆",
    roomNumber: "房間號",
    pleaseSelectTime: "請選擇時間",
    pleaseEnterNumber: "請輸入數字",
    selectAll: "全選",
    minute: "分",
    second: "秒",
    anchorTotalData: "主播總數據",
    totalSpecialEffectBeans: "總特效金豆",
    totalAllBeans: "總金豆",
  },

  micTime: {
    searchPlaceholder: "請輸入主播ID",
    search: "搜尋",
    dateSelect: "日期選擇",
    today: "當天",
    thisWeek: "本週",
    lastWeek: "上週",
    totalMicTime: "總麥時",
    date: "日期",
    anchorInfo: "主播資訊",
    micTime: "麥時",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
    minute: "分",
    second: "秒",
  },

  anchroOtayonii: {
    dateSelect: "日期選擇",
    byDay: "按天",
    byRange: "按區間",
    searchTime: "搜索時間",
    to: "至",
    dataSummary: "數據匯總",
    totalLuckyGift: "總幸運禮物",
    totalSpecialGift: "總特效禮物",
    totalKnapsackGift: "總背包禮物",
    anchorInfo: "主播資訊",
    luckyGift: "幸運禮物",
    specialGift: "特效禮物",
    knapsackGift: "背包禮物",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
  },

  roomCm: {
    dateSelect: "日期選擇",
    today: "當天",
    thisWeek: "本週",
    lastWeek: "上週",
    dataSummary: "數據匯總",
    totalTurnover: "總幸運金豆",
    totalTurnoverBeans: "總金豆",
    date: "日期",
    heartGiftTurnover: "幸運金豆",
    specialGiftTurnover: "總金豆",
    room: "房間",
    pleaseSelectTime: "請選擇時間",
    selectAll: "全選",
    minute: "分",
    second: "秒",
  },

  weekProfit: {
    dateSelect: "日期選擇",
    time: "時間",
    type: "類型",
    beans: "金豆",
    pleaseSelectTime: "請選擇時間",
  },

  coinManagement: {
    myGoldenbeans: "我的金豆",
    Withdraw: "提現",
    ExchangeGoldCoins: "兌換金幣",
    HostInformation: "主播資訊",
    WithdrawalCurrency: "提現幣種",
    SelectWithdrawalCurrency: "請選擇提現幣種",
    FiatCurrency: "法幣",
    PleaseSelectWithdrawalCurrency: "請選擇提現幣種",
    tips: "注：",
    tipsp0: "提現比例：10,000金豆=0.5USD",
    tipsp1: "提現門檻：100,000金豆，提現只能以10,000的倍數進行（首次提現需要200,000金豆，提現成功後降至100,000）",
    tipsp2:
      "綁定提現賬戶，由於異國打款方式多樣、無固定證件等特性，後臺添加賬號為家族長時需支持多種認證類型【具體打款方式以目前情況為準】",
    tipsp3: "需要認證主播",
    tipsp4: "綁定手機號",
    tipsp5: "以上步驟任意一個未達成時，均無法提現，此時頁面提示用戶或引導開通",
    tipsp6: "① 僅提示",
    tipsp7: "② 跳轉到手機號綁定頁，綁定完成後返回上圖頁面",
    tipsp8: "③ 跳轉到實名認證頁，綁定完成後返回上圖頁面",
    tipsp9: "④ 跳轉到賬戶綁定頁，綁定完成後返回上圖頁面",
    tipsp10: "提現會有一定的手續費，根據不同的通路手續費也將不同。",

    tipsp11: "1.兌換比例：1000金豆=500金幣",
    tipsp12: "2.最低5000金豆兌換，必須為1000的倍數",
    tipsp13: "3.兌換成功後不可撤回，請謹慎兌換",

    num: "數量",
    Custom: "自定義",
    PleaseEnter: "請輸入",
    Redeem: "兌換",
    SelectType: "類型選擇",
    GoldBeans: "金豆",
    GoldCoin: "金幣",
    WithdrawalAmount: "提款金額",
    PleaseNum: " 輸入要提取的coin數量",
    All: "全部",
    Withdraw: "提現",
    balance: "餘額",

    Incomedetails: "收入明細",
    Expensedetails: "支出明細",
    Nobeans: "沒有可兌換金豆",

    Record: "交易記錄",
    WithdrawalRecord: "提現記錄",
  },

  //提现记录
  withdrawRecord: {
    withdrawAmount: "提现金额",
    withdrawStatus: "提现状态",
    NoData: "暂无数据",

    // 添加状态翻译
    UnderReview: "待審核",
    Processing: "處理中",
    Completed: "完成",
    Rejected: "拒絕",
    Failed: "失敗",

    Pending: "待處理",
    Success: "成功",
    NoMore: "沒有更多了",
    PleaseWait: "請求中，請稍後...",
    PleaseSelect: "請選擇",
    Date: "日期",
    RealAmount: "實到金額",
    Fee: "手續費",
    Status: "狀態",
    Remark: "備註",
  },

  contactUs: {
    Officialcustomerservice: "官方客服服務",
    ContactUs: "聯繫我們",
    Issueofguild: "公會入駐問題",
  },

  myInvitation: {
    MyGoldBeans: "我的金豆",
    Share: "分享邀請更多好友",
    CopyLink: "複製連結",
    GoldCoinEarnedToday: "今日獲得金幣",
    TotalGoldCoin: "累計金幣",
    tips: "邀請綁定新用戶充值任意金額都可獲得1%金幣獎勵",
    tips2: "註冊時間超過48小時無法綁定",
    MyInvitations: "我的邀請",
    BillingDetails: "賬單明細",
    Total: "合計",
    People: "人",
    GoldCoinGiven: "贈送金幣",
    GiveGoldCoin: "多送+",
    InvitationLink: "邀請連結",
    ShareQR: "二維碼分享",
    InviteCount: "邀請人數",
    RevenueBeans: "收益金豆",
    InvitationDetails: "邀請明細",
    EarningsDetails: "收益明細",
    NickNameLabel: "用戶暱稱",
    SaveImage: "保存圖片",
    QRScanHint: "掃描二維碼或使用邀請連結加入",
    ShareTagline: "Share & Chat & Live",
    GoldenBeanUnit: "金豆",
    CommissionRate: "分成{rate}%",
  },

  userMisconduct: {
    title1: "內容違規 I",
    p1: "1.展示或傳播受限制內容：",
    p2: "包括在 Rain Live 的私聊、直播或其他功能中傳播色情、低俗、暴力或種族主義內容。",
    p3: "2.散布仇恨言論：",
    p4: "禁止發表針對宗教、種族、政治或國家身份的仇恨言論。",
    p5: "3.推廣或拉人：",
    p6: "禁止通過直播、私聊或審核過的評論邀請用戶加入其他應用程式或平台。",
    title2: "後果",
    p7: "涉及此類違規行為的賬戶、設備或 IP 地址可能會被封禁。",

    title3: "內容違規 II",
    p8: "1.分享私人信息：",
    p9: "禁止通過 Rain Live 的直播、評論或私聊功能傳播私人信息，例如電話號碼、賬號 ID、Facebook 賬戶、照片等。",
    p10: "2.賬戶濫用：",
    p11: "禁止向他人提供、出租或出售 Rain Live 賬戶。",
    p12: "3.利用私人信息：",
    p13: "禁止未經用戶同意使用或傳播其私人信息（照片、暱稱等）以謀取私利或惡意攻擊他人。",
    title4: "後果",
    p14: "違規用戶將被永久封號。",
  },

  landingPage: {
    info1: "Rain直播圈",
    info2: "Apl內部採購",
    item1: "45K條點評",
    item2: "下載",
    item3: "等級3級 3+",
    btn: "下載",
    title: "關於Rain直播",
    content:
      "Rain直播是一款暖心的面向所有人的在線直播軟件，包括語音、視頻、娛樂、遊戲等。平台聚集了高顏值主播，是一個有深度和內容的直播平台。激烈PK、活動不停，炫酷禮物、享受帝王般尊貴體驗。",
    tips: "Rain直播在線在社交應用程序的熱門免費列表中排名第一。",
  },

  equityLevel: {
    Experience: "經驗值",
    Level: "當前等級",
    Berikutnya: "距離升級",
    title1: "等級特權",
    desc1: "等級越高，圖標等級越尊貴，越容易得到心儀主播的青睞",
    title2: "如何升級",
    desc2: "1、用戶等級由您禮物消費的所得的經驗值數量決定",
    desc3: "2、您可以通過每日送禮物消費來獲得經驗值進行等級提升",
    desc4: "3、幸運禮物，每消耗1金幣獲得1經驗值",
    desc5: "4、特效禮物，每消耗1金幣獲得10經驗值",
    title3: "等級特權",
    desc6: "等級越高，圖標等級越尊貴，越容易得到用戶的青睞",
    title4: "如何升級",
    desc7: "1、主播等級由您收到禮物的所得的經驗值數量決定",
    desc8: "2、您可以通過每日收禮物數量來獲得經驗值進行等級提升",

    title6: "用戶等級",
    title7: "等級",
    title8: "等級勳章",
    title9: "主播等級",
    title10: "累計經驗值",
    LevelDescription: "等級說明",
    tabUser: "用戶",
    tabEx: "Ex幣",
    tabAnchor: "主播",
    titleOverview: "財富等級一覽",
    nickNameUser: "用戶暱稱",
    nickNameAnchor: "主播暱稱",
    nickNameEx: "用戶暱稱",
    exPrivilegeDesc: "等級越高，圖標等級越尊貴，越容易得到用戶的青睞",
    exDesc1: "1、Ex等級由您禮物消費的所得的經驗值數量決定",
    exDesc2: "2、您可以通過每日送禮物消費來獲得經驗值進行等級提升",
    exDesc3: "3、幸運禮物，每消耗1金幣獲得1經驗值",
    exDesc4: "4、特效禮物，每消耗1金幣獲得10經驗值",
    anchorPrivilegeDesc: "等級越高，圖標等級越尊貴，越容易得到用戶的青睞",
    anchorDesc1: "1、主播等級由您收到禮物的所得的經驗值數量決定",
    anchorDesc2: "2、您可以通過每日收禮物數量來獲得經驗值進行等級提升",
  },

  applyJoin: {
    tips1: "請輸入您的 WhatsApp 帳號",
    title2: "照片要求",
    tips2: "請展示您的臉部和上半身，並將雙手擺成貓咪的姿勢",
    tips3: "此照片將用於公司的審核，並且有關部門會對其保密。",
    tips4: "照片必須是您自己的。",
    title3: "視頻要求",
    tops5: "視頻必須展示您本人。",
    tips6: "視頻長度應在 10 到 20 秒之間。",
    status1: "提交審核",
    status2: "審核中",
    status3: "審核成功",
    status4: "審核失敗",
    LiveMode: "直播模式",
    Video: "視頻",
    Voice: "語音",

    MP4: "請選擇MP4格式視頻",
    pngOrJpg: "請上傳 PNG 或 JPG 格式圖片",
    UploadingWait: "上傳中，請稍後",
    CompleteInformation: "請完善信息",
    TabPersonalStreamer: "主播認證",
    TabJoinGuild: "加入公會",
    faceVerifyTitle: "人臉核驗",
    faceVerifyPending: "待認證",
    faceVerifyVerified: "已認證",
    faceVerifyError: "您已認證其他帳號，無法驗證",
    faceVerifyRequired: "請先完成人臉核驗",
    faceVerifyNotSupported: "當前環境不支持人臉核驗",
    faceVerifyStart: "開始",
    faceVerifyRetry: "重試",
    faceVerifySuccess: "認證成功",
    faceVerifyFail: "認證失敗",
  },
  cancelAccount: {
    title: "申請註銷賬號",
    tips: "以下信息將被清空且無法找回",
    p1: "註銷賬號後，所有信息將被永久刪除（包括關注、粉絲等），您已購買的增值服務將不再保留且無法轉移至其他賬號（如VIP、靚號、頭像框等）。",
    p2: "綁定的Facebook、Twitter、Apple、Google賬號將會解除綁定，解除後可重新註冊。",
    p3: "您申請主播的信息將被解除綁定，解除後可重新綁定其他賬號。（如果您是直播主播用戶，您的主播信息可再次認證並啟動直播）。",
    p4: "賬號註銷後，賬戶剩餘的金幣、鑽石、經驗值、座駕、貴族等收益相關數據將被清空，如產生利益損失，將由賬號註銷申請人自行承擔。",
    p5: "如果您是公會長，提交註銷賬號後，公會將自動解散。（公會解散後，撤回申請也無法恢復公會）；如果您是公會成員，註銷賬號後將自動退出公會。（在15天內的申訴期內撤回註銷可恢復）。",
    p6: "如果您是家族長，提交註銷賬號時，需要先解散或退出家族。",
    p7: "如果您是家族成員（非家族長），提交註銷賬號時，將立即退出家族。（在15天內的申訴期內撤銷註銷不可恢復）。",
    p8: "提交註銷申請後，存在15天的申訴期。在申請期內登錄，將自動取消註銷。申訴期到期後，賬號將自動註銷且無法找回。如在此期間因非本人操作或誤操作等原因需要找回賬號，請聯繫客服申訴。(客服Whatsapp：+62 81188011180，或郵箱：rainlive888@gmail.com）",
  },

  Proxy: {
    Hello: "您好,",
    Welcome: "歡迎來到Rain Chat！",
    Account: "賬號",
    Pleaseenter: "請輸入",
    Password: "密碼",
    Login: "登錄",
    MyAgent: "我的代理",
    Nickname: "代理暱稱",
    CoinBalance: "代理幣餘額",
    TransferRecord: "轉賬記錄",
    Recharge: "充值",
    ExchangeProxyCoin: "兌換代理幣",
    TransferInformation: "請填寫轉賬信息",
    Reset: "重置",
    RecipientID: "對方ID",
    RecipientNickname: "對方暱稱",
    TransferAmount: "轉賬金額",
    TotalTransferAmount: "總計",
    Transfer: "轉賬",
    KindReminder: "溫馨提示",
    DoubleCheck: "請核對一下轉賬信息，確保無誤",
    SelectAmount: "請選擇需要充值的金額",
    SelectMonth: "選擇月份",
    Username: "用戶名稱",
    TransferTime: "轉賬時間",
    AutoFill: "自動填充",
    Rechargeselection: "充值選擇",
    ProxyCurrency: "代理幣不足",
    PaymentAmount: "支付金額",
    PleaseSelectAmount: "請選擇充值金額",
    GoldExchangeTitle: "金豆兌換代理幣",
    GoldBalanceLabel: "金豆餘額：",
    InputGoldPlaceholder: "輸入金豆",
    AvailableProxyCoin: "可獲得代理幣",
    GiftProxyCoin: "贈送 {amount} 代理幣",
    GiftBonusPercent: "贈送{bonus}%",
    Exchange: "兌換",
    Tip: "提示",
    ExchangeConfirmHtml:
      '您將使用<span class="green">{gold}</span>金豆兌換<span class="green">{coin}</span><br/>代理幣，獲贈<span class="orange">{gift}</span>代理幣。',
    ExchangeSuccessTitle: "兌換成功",
    ExchangeSuccessText: "代理幣已到賬，請注意查收。",
    ExchangeFail: "兌換失敗",
    RequestFail: "請求失敗",
  },
  bd: {
    index: {
      guildCount: "公会数",
      weekEstimatedIncome: "本周预估收益",
      lastWeekIncome: "上周收益",
      inviteCode: "邀请码",
      searchPlaceholder: "请输入公会ID",
      enterGuildId: "请输入公会ID",
      searchGuild: "搜索公会",
      lastWeek: "上周",
      weekIncome: "本周工会收益",
      myIncome: "我的收益",
      effectiveLive: "有效开播",
      bindDays: "绑定天数",
      summary: "汇总",
      guildName: "公会名称",
      guildId: "公会ID",
      guildIncome: "公会收益",
      effectiveLive: "有效开播",
      myIncome: "我的收益",
      date: "日期",
      noData: "暂无数据",
      searching: "搜索收益数据",
      showingSummary: "显示汇总数据",
      loading: "加载中...",
      loadFailed: "加载失败",
      networkError: "网络错误，请稍后重试",
      selectWeek: "选择周期",
    },
    incomeDetail: {
      title: "收益详情",
      lastWeekIncome: "上周收益",
      totalIncome: "总收益",
      guildId: "公会ID",
      date: "日期",
      thisWeek: "本周",
      lastWeek: "上周",
      beforeLastWeek: "上上周",
      thisMonth: "本月",
      lastMonth: "上月",
      guildName: "公会名称",
      guildIncome: "公会收益",
      search: "搜索",
      showSummary: "显示汇总",
      noData: "暂无数据",
      searching: "搜索收益数据",
      showingSummary: "显示汇总数据",
      guildId: "公会ID",
      guildName: "公会名称",
      guildIncome: "公会收益",
      effectiveLive: "有效开播",
      myIncome: "我的收益",
      date: "日期",
    },
  },
  noble: {
    expireTime: "到期時間",
    canReceive: "可領取{coin}金幣",
    receive: "立即領取",
    received: "已經領取",
    becomeNoble: "成為貴族",
    totalCanGet: "總計可獲得{price}{totalCoin}金幣",
    silver: "白銀",
    gold: "黃金",
    platinum: "鉑金",
    diamond: "鑽石",
    obsidian: "黑曜",
    type: "權益",
    levelReward: "說明",
    dailyExCoin: "免費 Ex 幣",
    rechargeReward: "Top up",
    gameSupport: "Game 權益",
    exclusiveDecoration: "裝扮",
    decoration: {
      profileCard: "資料卡",
      bubble: "氣泡框",
      vehicle: "座駕",
      avatarFrame: "頭像框",
      badge: "銘牌",
    },
    dailyFreeExCoin: "每日免費{amount}Ex幣",
    monthlyRechargeBenefit:
      "每月充值的{percent}%額度作為權益金，次月發放至賬戶。",
    monthlyGameConsumptionBenefit:
      "每月遊戲消耗金幣的{percent}%，次月發放至賬戶。",
    privileges: {
      getCoin: "領金幣",
      avatarFrame: "頭像框",
      medal: "勳章",
      vehicle: "座駕",
      purchaseNotification: "購買通知",
      chatBubble: "聊天氣泡",
      colorfulNickname: "彩色暱稱",
      specialId: "專屬ID",
      mystery: "神秘人",
      exclusiveService: "專屬服務",
      title: "權益",
      Effect: "房間入場特效",
    },
    contactOperation: "請聯繫運營獲取",
    receiveSuccess: "領取成功",
    level1Recharge: "白銀貴族 /30天",
    level2Recharge: "黃金貴族 /30天",
    level3Recharge: "鉑金貴族 /30天",
    level4Recharge: "鑽石貴族 /30天",
    level5Recharge: "黑曜貴族 /30天",
    vipCenterTitle: "貴族中心",
    expireTimeText: "有效期至",
    openVip: "充值開通",
    reachedLevel: "已達到該等級",
    stillNeedCoins: "還需充值 {amount} 金幣",
    stillNeedCoinsToKeepGrade: "還需充值{amount}完成保級",
    stillNeedCoinsToActivate: "還需充值{amount}可開通{levelName}",
    keepGradeCompleted: "續期",
    keepGradeProgress: "保級進度：",
    progress: "進度",
  },
  bonusActivity: {
    title: "直播額外獎勵",
    activityTime: "活動時間：2025年4月7日至2025年5月4日 (UTC+8)",
    rewardRules: "獎勵規則",
    reward: "獎勵",
    totalReceived: "總計領取",
    bonus: "獎金",
    claim: "領取",
    claimed: "已領取",
    notAchieved: "未達成",
    duration: "長時 (小時)",
    target: "目標 (金幣)",
    note: "註：達成目標後，獎金可於次日領取。",
    activityCalendar: "活動日曆",
    april: "四月",
    may: "五月",
    claimSuccess: "領取成功",
  },
  bonusActivityRule: {
    activityDescription: "活動說明",
    descriptionContent: "主播在基礎獎勵之上，還將額外獲得Rain Live給予的獎勵。",
    activityTime: "活動時間",
    timeContent1: "2025年4月7日至2025年5月4日（UTC+8）",
    timeContent2: "每天的0點(UTC+8)時，將開啟下一天的獎勵",
    claimMethod: "領取方式",
    claimContent: "當天達成目標時，次日可手動領取獎勵。",
    rewardTable: "獎勵表：",
    targetTurnover: "目標流水",
    activityReward: "活動獎勵",
  },
  inviteFriends: {
    invitationEventTitle: "邀請活動",
    inviteAndEarnRewards: "邀請有獎",
    eventPeriod: "活動時間：4月7日 00:00 - 5月4日 23:59:59 (UTC+8)",
    invitationRecord: "邀請記錄",
    eventDetails: "活動說明",
    week1DateRange: "第一週：4月7日 - 4月13日",
    totalInvitedExample: "已邀請人數",
    level1RewardText: "Lv.1 邀請20人 20000金幣",
    level2RewardText: "Lv.2 邀請50人 50000金幣",
    level3RewardText: "Lv.3 邀請100人 100000金幣",
    statusClaimed: "已領取",
    actionClaim: "領取",
    statusNotAchieved: "未達成",
    topUpRewardsLabel: "充值獎勵：",
    copyInvitationLink: "複製邀請鏈接",
    rewardNote: "註：被邀請人充值時，你可獲得對應金幣的2%獎勵。",
    copySuccess: "複製成功",
    claimSuccessExample: "成功領取20000金幣",
    userIDLabel: "用戶ID",
    userNameLabel: "用戶名稱",
    timeLabel: "時間",
    topUpLabel: "充值",
    eventPurposeTitle: "【活動目的】",
    eventPurposeDesc:
      "為感謝用戶長期以來對 Rain Live 的支持與喜愛，平台特推出「邀請好友・多重有禮」活動，誠邀您與好友共享精彩直播體驗！",
    eventDurationTitle: "【活動時間】",
    eventDateRange: "2025年4月7日至2025年5月",
    eventCycleDesc: "共4週，每週一 0 點 (UTC+8) 開啟新周期獎勵",
    rewardRulesTitle: "【獎勵規則】",
    rewardRulesDesc1: "除本次活動獎勵外，還可正常享受原邀請獎勵：",
    rewardRulesDesc2: "用戶充值金幣的2%將額外獎勵給邀請人。",
    importantNotesTitle: "【注意事項】",
    importantNotesDesc:
      "⚠️ 禁止通過虛假帳號、機器註冊等惡意行為刷取獎勵，一經發現將立即收回所有獎勵，並可能限制帳號功能；",
  },
  gameRanking: {
    notRanked: "未上榜",
    distanceToRank: "距離50名還差{points}積分",
    distanceToBeforeRank: "距離第{rankId}名還差{points}積分",
    rank1: "您已經是第一名了",
    today: "今天",
    yesterday: "昨天",
    ruleBtn: "規則",
    rules: {
      pointsStats: {
        title: "積分統計規則",
        conversion:
          "1. 積分轉換標準：1金幣等於活動中的1積分，參與者的積分將直接根據金幣數量計算。",
        timeRange:
          "2. 統計時間範圍：每日積分統計週期為00:00至23:59（UTC+8時區），超出此時間範圍的金幣數據將計入次日統計。",
      },
      ranking: {
        title: "排名和獎勵規則",
        basis:
          "3. 排名依據：系統將根據參與者每日最終積分（即當日金幣總數）進行降序排名，以確定每日排名。",
        rewards: "4. 獎勵設置：",
        reward1: "排名第1：獎勵250,000金幣",
        reward2: "排名第2：獎勵150,000金幣",
        reward3: "排名第3：獎勵100,000金幣",
        reward4: "排名第4：獎勵50,000金幣",
        reward5: "排名第5：獎勵50,000金幣",
      },
      pointsCalculation: {
        description: "遊戲流水最低5,000,000是獲得活動獎勵的必要條件。",
      },
      helpReward: {
        description:
          "助力獎勵：若達到對應要求，但未領取到排名獎勵時，會獲得該助力獎勵。",
      },
      turnoverRewards: {
        title: "流水獎勵規則",
        turnover: "流水",
        reward: "獎勵",
        turnover1M: "100萬",
        reward10K: "10,000金幣",
        turnover3M: "300萬",
        reward30K: "30,000金幣",
        turnover5M: "500萬",
        reward50K: "50,000金幣",
      },
      distribution: {
        title: "獎勵發放規則",
        description:
          "對應每日排名的獎勵將在次日統一發放。參與者可在次日登錄活動頁面或個人賬戶查看獎勵領取狀態。",
      },
      violation: {
        title: "違規處罰規則",
        description:
          "活動期間，嚴禁參與者使用系統漏洞、外掛或任何其他手段通過刷取積分（金幣）進行作弊。如發現：",
        penalty1: "5. 首次違規者將取消當日獎勵資格；",
        penalty2:
          "6. 情節嚴重或多次違規者將直接禁止參與本活動及後續相關活動，且不恢復參與權利。",
      },
    },
  },
  bonusPoints: {
    activityTime: "活動時間",
    resetTime: "每日0點(UTC+8)重置",
    pointsReward: "積分獎勵",
    coinsReward: "金幣獎勵",
    participationTimes: "參與{times}次",
    points: "積分",
    exchange: "兌換",
    pointsMall: "積分商城",
    betSum: "當前流水",
    note: "註",
    rule1: "1、可透過完成每日積分任務獲得積分",
    rule2: "2、積分商城的獎勵將會不定期更換",
    rule3: "3、兌換成功後，積分不可退換，請謹慎兌換",
    coins: "金幣",
    claim: "領取",
    claimed: "已領取",
    notAchieved: "未達成",
    reach: "達成",
  },

  // 公會活動
  guildActivity: {
    activityRules: "活動規則",
    ruleBtn: "規則",
    tabThis: "本期",
    tabLast: "上期",
    rulesContent: {
      activityTime: "活動時間：9月29日開始",
      rankingRewards: "排名獎勵",
      requirements: "要求",
      rewardDistribution: "獎勵發放",
      rewardList: {
        first: "第一名：1000000金豆",
        second: "第二名：500000金豆",
        thirdToFifth: "第3-5名：250000金豆",
        sixthToTenth: "第6-10名：100000金豆",
        eleventhToTwentieth: "第11-20名：50000金豆",
      },
      requirementText:
        "機構主播當週必須完成至少30場直播，每位主播每天直播超過2小時算作一次",
      distributionText: "獎勵將於第二週發放",
    },
  },

  // 魅力榜/消費榜排行榜
  charmRanking: {
    charmRanking: "魅力榜",
    consumptionRanking: "消費榜",
    dailyRanking: "日榜",
    weeklyRanking: "周榜",
    userNickname: "用戶暱稱",
    distanceToPrevious: "距前一名",
    noRankingData: "暫無排行榜數據",
    requestFailed: "請求失敗",
  },

  // 邀請活動
  inviteActivity: {
    title: "邀請3人必得獎勵",
    rule: "規則",
    alreadyJoined: "已加入",
    inviteImmediately: "立即邀請",
    callNumber: "邀請",
    myRewards: "我的獎勵",
    claim: "領取",
    claimed: "已領取",
    people: "人",
    inviteFriends: "邀請朋友",
    processTitle: "邀請流程：",
    step1: "1.發送鏈接給朋友",
    step2: "2.朋友下載並註冊",
    step3: "3.獲得免費金幣",
    rulesTitle: "邀請規則",
    rulesContent: {
      rule1: "邀請達到3人時，可領取16666金豆",
      rule2: "邀請達到25人時，可再領取36666金豆",
      rule3: "邀請達到100人時，可再領取88888金豆總計可領142220金豆。",
      rule4: "獎勵於活動頁面手動領取。",
      rule5: "嚴禁惡意刷取人數，若發現將進行封號處理",
    },
    close: "關閉",
    inviteFeatureComingSoon: "邀請功能即將上線",
    rewardReceived: "成功獲得 {amount} 金幣！",
  },

  // 贈送金幣頁面
  giftGoldCoins: {
    maxGiftableCoins: "最大可贈送金幣",
    giftAmount: "贈送金幣數量",
    customAmount: "自定義贈送金幣數量",
    enterAmount: "請輸入金額",
    quantity: "數量",
    giftToOtherAccounts: "贈送至其他賬號",
    exceedMaxAmount: "金額不能超過最大可贈送數量",
    amountSet: "金額設置成功",
    invalidAmount: "請輸入有效金額",
    selectValidAmount: "請選擇有效金額",
    confirmTitle: "確認贈送",
    confirmMessage: "確定要贈送 {amount} 金幣嗎？",
    giftSuccess: "贈送成功",
    giftId: "贈送ID",
    enterGiftId: "請輸入ID",
    pleaseEnterGiftId: "請輸入贈送ID",
    giftCompleted: "贈送完成！",
    giftedToId: "贈送至ID",
    networkError: "網絡錯誤，請稍後重試",
    confirm: "確定",
  },

  // 裝扮商店
  shop: {
    headerTitle: "個人裝扮",
    back: "返回",
    shoppingBag: "購物袋",
    loading: "加載中...",
    noProducts: "暫無商品",
    unnamedProduct: "未命名商品",
    day: "天",
    myCoins: "我的金幣",
    exchangeNow: "立即兌換",
    notSelected: "未選中",
    loginExpired: "登錄失效，請重新登錄",
    categoryNotExists: "分類不存在",
    loadFailed: "加載失敗",
    loadFailedRetry: "加載失敗，請重試",
    pleaseSelectProduct: "請先選擇商品",
    productNotExists: "商品不存在",
    insufficientCoins: "金幣不足，需要{amount}金幣",
    exchangeSuccess: "兌換成功",
    exchangeFailed: "兌換失敗",
    categories: {
      hot: "熱門",
      avatarFrame: "頭像框",
      entryEffect: "進場特效",
      chatBubble: "聊天氣泡",
      mount: "坐騎",
    },
    recharge: "充值 >",
    validityPeriod: "有效期:",
    myCoinsLabel: "我的金幣:",
  },
  myDecoration: {
    headerTitle: "我的裝扮",
    back: "返回",
    noWearingDecoration: "暫無選中的穿戴裝扮",
    loading: "加載中...",
    noDecoration: "暫無裝扮",
    unnamedDecoration: "未命名裝扮",
    permanent: "永久",
    wearing: "穿戴中",
    pleaseSelectDecoration: "請選擇裝扮",
    removeDecoration: "卸下裝扮",
    wearNow: "立即穿戴",
    pleaseSelectDecorationFirst: "請先選擇裝扮",
    decorationNotExists: "裝扮不存在",
    loginExpired: "登錄失效，請重新登錄",
    loadFailed: "加載失敗",
    loadFailedRetry: "加載失敗，請重試",
    wearSuccess: "穿戴成功",
    wearFailed: "穿戴失敗",
    previewAnimation: "預覽動畫",
    categories: {
      hot: "熱門",
      avatarFrame: "頭像框",
      entryEffect: "進場特效",
      chatBubble: "聊天氣泡",
      mount: "坐騎",
    },
  },
  // 聖誕活動/幸運星活動
  christmasActivity: {
    dailyLuckyStar: "每日幸運星",
    weeklyLuckyStar: "每週幸運星",
    startTime: "Start time:",
    obtainedCount: "獲得個數",
    moreChance: "數量越多機會越多",
    participated: "已參與",
    notParticipated: "未參與",
    historyRecord: "歷史記錄",
    myRecord: "我的記錄",
    noRecord: "暫無記錄",
    loading: "加載中...",
    noMore: "沒有更多了",
    coin: "金幣",
    unit: "個",
    notWon: "未中獎",
    conditionNotMet: "條件未滿足",
    claimSuccess: "領取成功",
    getRecordFailed: "獲取記錄失敗",
    rules: {
      title: "活動規則",
      rule1: "每日幸運星",
      rule2: "每日幸運星活動，所有用戶可參與。",
      rule3:
        "向主播贈送對應禮物時，可獲得禮物個數累計，當贈送的禮物數量滿足要求時，即可參與到紅包開獎中，每次都將會有幸運兒獲得金幣獎勵。",
      rule4: "贈送禮物個數越多，獲獎機會越高",
      rule5: "每週幸運星",
      rule6: "週幸運星活動，所有的主播可參與。",
      rule7:
        "當收到用戶贈送的對應禮物時，會獲得數量累計，收到足夠的禮物數量時，可參與週幸運星紅包開啟，每次都將有幸運兒獲得獎勵。",
      rule8: "獲得禮物個數越高，獲獎機會越高",
      rule9: "其他說明",
      rule10: "此次活動為福利大回饋。",
      rule11: "僅向其他主播贈送時，可累計個數。",
      rule12: "嚴禁利用漏洞獲得獎勵。",
      rule13: "每個時間段的獎勵將自動發放，可查看獲獎記錄，了解中獎情況",
    },
  },
  // 幸運星積分排行活動
  fortuneStarActivity: {
    points: "積分",
    pointsRanking: "積分排行",
    currentRoundPoints: "本場積分",
    lastRoundPoints: "上場積分",
    defaultUserName: "用戶名稱",
    noData: "暫無數據",
    activityRules: "規則",
    historyRecord: "歷史記錄",
    earnedPoints: "獲得積分",
    participated: "已參與",
    notParticipated: "未滿足",
    myRecord: "我的記錄",
    userId: "ID",
    userNickname: "用戶暱稱",
    sessionTime: "場次時間",
    winningStatus: "中獎情況",
    won: "已中獎",
    notWon: "未中獎",
    rules: {
      rule1: "活動期間，用戶通過贈送指定禮物可獲得積分",
      rule2: "積分將實時累計，可查看當前積分排名",
      rule3: "活動結束後，排名靠前的用戶將獲得豐厚獎勵",
      rule4: "嚴禁使用任何作弊手段獲取積分，違者將取消資格",
      rule5: "活動最終解釋權歸平台所有",
    },
  },

  // 盲盒活動
  blindBox: {
    title: "玩法介紹",
    ruleTitle: "玩法介紹",
    rule1:
      "每{price}金幣可開{text}一次，用戶贈送該禮物後可變出不同的禮物，變出禮物將會自動贈送給所指定的麥上用戶",
    rule2: "贈送{text}用戶在該禮物所變出的禮物自動送出後可獲得對應的金豆。",
    rewardTip: "獎勵提示",
    probabilityDesc: "具體概率如下：",
    prize: "獎品",
    probability: "概率",
    value: "價值",
  },

  taskHub: {
    tabCenter: "任務中心",
    tabAnchor: "主播任務",
    signTitle: "7日簽到",
    signStreakBefore: "連續簽到 ",
    signStreakAfter: " 天",
    signBtn: "簽到",
    signBtnDone: "已簽到",
    signPeriod: "本期簽到: {start} - {end}",
    dayLabel: "Day{n}",
    avatarFrame: "頭像框",
    activeTasks: "用戶活躍任務",
    timeLeft: "剩餘時間: {t}",
    claimable: "可領取",
    inProgress: "進行中",
    rewardGain: "可獲得 {n} EX幣",
    taskWatchLive: "觀看直播三十分鐘",
    taskFollowHosts: "關注3名主播",
    taskSpeakRooms: "在不同房間發言3次",
    taskGiftCoins: "消費100金幣用於送禮",
    taskGameCoins: "消費100金幣用於遊戲",
    taskRechargeToday: "今日充值一次",
    unitMinutes: "分鐘",
    unitHosts: "名主播",
    unitTimes: "次",
    unitCoins: "金幣",
    unitDays: "天",
    toastSigned: "簽到成功",
    toastClaimed: "領取成功",
    claimSuccessTitle: "領取成功",
    claimSuccessOk: "知道啦",
    toastInProgress: "任務進行中",
    toastLoadFail: "加載失敗",
    claimed: "已完成",
    toastRefreshed: "已刷新",
    anchorActivity: "活動",
    weekDurationTitle: "周時長活動",
    activityPeriod: "活動週期",
    weekLiveDuration: "本周開播時長",
    weekRank: "本周排名",
    claimableReward: "可領取獎勵",
    effectExtraTitle: "特效額外獎勵",
    effectBeansToday: "當天收到特效金豆",
    rewardDate: "獎勵日期 {date}",
    claimableAmount: "可領取",
    claimNow: "立即領取",
    claimedToday: "當天已領取:",
    effectNote: "注：當天獎勵最晚於次日1:00 (UTC+8) 前領取",
    todayData: "Today Data",
    todayLiveDuration: "當天直播時長",
    liveHintShort: "還差{remain}",
    needMoreBeans: "還差{n}",
    toastNoClaimable: "暫無可領取獎勵",
    toastClaimPending: "領取接口待對接",
    luckyBeans: "幸運金豆",
    nextDayLucky: "次日幸運獎勵",
    upgradeBeansTitle: "升級領取金豆",
    upgradeReward: "升級獎勵",
    weekData: "Week Data",
    totalLiveDuration: "總直播時長",
    validDays: "有效天數",
    weekLuckyReward: "本週幸運獎勵",
    dayDataTitle: "今日數據",
    monthDataTitle: "當月數據",
    weekDataTitle: "當周數據",
    monthLiveDuration: "當月直播時長",
    weekLiveDuration: "當周直播時長",
    specialBeans: "特效金豆",
    totalBeans: "總金豆",
  },

  pcOfficial: {
    navHome: "首頁",
    navLive: "實時直播",
    navGameHall: "遊戲大廳",
    received: "收到",
    heroTagline: "全球領先的 Web4 娛樂平台",
    heroTaglineSub:
      "性感主播 7*24 小時實時互動，頂級鏈遊體驗。基於去中心化技術，確保每一筆交易即時獎勵，公平公正",
    downloadNow: "立即下載",
    giftCoin: "Ex幣",
    giftAvatarFrame: "頭像框",
    bottomDownloadAndroidApk: "Android APK",
    recommendTitle: "熱門主播推薦",
    recommendSub: "萬千女神實時互動，帶你領略 P2E 鏈遊魅力",
    hotGamingTitle: "熱門遊戲",
    hotGamingSub: "真實玩家，真實排名。你會是下一個傳奇嗎？",
    casinoTitle: "娛樂城",
    casinoDesc1: "與真人荷官同場競技，暢玩百家樂，",
    casinoDesc2: "輪盤與 21 點，高清沉浸體驗",
    slotsTitle: "老虎機",
    slotsDesc: "海量高品質老虎機，98.5% RTP 高回報",
    gamingTitle: "遊戲",
    gamingDesc: "不止轉盤，體驗多人競技技巧遊戲",
    whyTitle: "為什麼選擇 Rain Live",
    whyItem1Title: "公平公正",
    whyItem1Desc: "經審計 RNG，保證每局公平",
    whyItem2Title: "極速到賬",
    whyItem2Desc: "提現快速，到賬及時",
    whyItem3Title: "匿名隱私",
    whyItem3Desc: "無需個人信息，100% 隱私保護",
    whyItem4Title: "去中心化",
    whyItem4Desc: "鏈上透明、安全可信",
    terms: "服務條款",
    privacy: "隱私政策",
    navRecharge: "充值",
    rechargeAccountTitle: "充值賬號",
    idLogin: "ID 登錄",
    accountIdLabel: "賬號ID：",
    accountIdPlaceholder: "請輸入賬號ID",
    confirm: "確認",
    defaultUserName: "用戶名",
    userIdWithValue: "ID:{id}",
    switchAccount: "切換賬號",
    rechargeQuantityTitle: "充值數量",
    goToPay: "前往支付",
    topUpAmountTitle: "充值金額",
    pay: "支付",
    channelDefault: "支付渠道",
    toastInvalidAccountId: "請輸入有效賬號ID",
    toastNoTokenAfterLogin: "登錄成功但未獲取到 token",
    toastLoginFailed: "登錄失敗",
    toastCoinPackagesFailed: "獲取充值列表失敗",
    toastPayChannelsFailed: "獲取支付渠道失敗",
    toastOrderParamsMissing: "訂單參數缺失，無法發起支付",
    toastNoPayUrl: "支付地址不存在",
    toastCreateOrderFailed: "創建支付訂單失敗",
    rainLiveRecharge: "Rain Live 充值",
    selectCountryTitle: "選擇國家/地區",
    selectChannelTitle: "選擇支付渠道",
    rechargeLoading: "加載中...",
    rechargePackagesEmpty: "暫無可用充值檔位",
    rechargeLoginHint: "請先使用 ID 登錄",
  },

  liveDuration: {
    tabthisWeek: "本週",
    tablastWeek: "上週",
    eventTime: "活動時間：{time}",
    rewardCoin: "獎勵金幣",
    liveHours: "直播時長",
    myRank: "我的排名",
    zeroHours: "0小時",
    hoursOnly: "{hours}小時",
    minutesOnly: "{minutes}分鐘",
    hoursMinutes: "{hours}小時{minutes}分鐘",
  },

  // USDT 充值訂單支付頁
  topUpUsdt: {
    orderNo: "訂單號",
    copy: "複製",
    copyOrderNo: "複製訂單號",
    copyAddress: "複製收款地址",
    productName: "RainChat 金幣",
    quantityUnit: "× {count} 枚",
    orderAmount: "訂單金額",
    scanToPay: "掃碼支付",
    scanTip: "使用錢包 App 掃描二維碼完成支付",
    qrAreaAlt: "支付二維碼區域",
    qrCodeAlt: "支付二維碼",
    receivingAddress: "收款地址",
    validityPrefix: "有效期",
    validityMinutes: "{minutes} 分鐘",
    validitySuffix: "，請盡快支付",
    orderNoCopied: "訂單號已複製",
    addressCopied: "收款地址已複製",
    nothingToCopy: "暫無可複製內容",
    copyFailed: "複製失敗，請手動複製",
    promptTitle: "提示",
    rechargePrompt: "如已充值，請點擊完成充值",
    cancel: "取消",
    completeRecharge: "完成充值",
    rechargeCompleted: "✔充值完成",
    rechargeCompletedText: "充值完成",
    rechargePending: "目前查詢未到賬，可能存在延遲，到賬後金幣將會自動添加",
    gotIt: "明白了",
  },

  rainChatOfficial: {
    appNotDetected: "未偵測到 App，請下載",
  },

  // 體驗幣幸運轉盤活動
  luckyTurntable: {
    draw: "抽獎",
    drawing: "抽獎中",
    task: "任務",
    recharge: "充值",
    historyRecord: "歷史記錄",
    balanceLabel: "體驗幣餘額：",
    exGradeTip: "Ex等級Lv.{grade} · 需要 Lv.{level} 參與",
    got: "獲得",
    defaultNotice: "用戶暱稱 {got} 體驗幣",
    insufficientBalance: "餘額不足",
    exGradeNotMet: "Ex等級未達標",
    configLoadFailed: "設定載入失敗，請稍後重試",
    recordLoadFailed: "記錄載入失敗，請稍後重試",
    drawResultError: "抽獎結果異常，請稍後重試",
    drawFailed: "抽獎失敗，請稍後重試",
    winTitle: "恭喜獲得",
    winConfirm: "知道啦",
    loading: "載入中...",
    noRecord: "暫無記錄",
    noMore: "沒有更多了",
  },

  rewardActivity: {
    moreReward: "More",
    tabInvite: "邀請活躍",
    tabWelfare: "七天福利",
    tabMic: "上麥獎勵",
    inviteTitle: "邀請用戶活躍獎勵",
    yesterdayData: "昨日數據",
    yesterdayActive: "昨日活躍人數",
    goldBean: "金豆",
    todayDataRealtime: "今日數據（實時）",
    todayActive: "今日活躍人數",
    peopleUnit: "人",
    estimateReward: "預計獎勵",
    claimTomorrowTip: "次日10:00可領取",
    claimAt10: "10點可領取",
    claimYesterday: "領取昨日獎勵",
    claimed: "已領取",
    noReward: "暫無獎勵",
    viewDetail: "查看明細",
    welfareTitle: "新主播七天福利",
    personalNewHost: "個人新主播",
    rule: "規則",
    welfareRemain: "福利剩餘時間",
    dayUnit: "天",
    minuteUnit: "分鐘",
    day1: "第1天",
    day7: "第7天",
    todayData: "今日數據",
    todayMicDuration: "今日上麥時長",
    claimableBean: "可領取金豆",
    claimReward: "領取獎勵",
    claimTodayReward: "領取今日獎勵",
    todayCanClaim: "今日還可領{amount}",
    needMic60: "今日上麥60分鐘即可領取",
    needMic120: "今日上麥120分鐘即可領取",
    todayClaimedAll: "今日獎勵已領完",
    becomeAnchor: "成為主播，即可領獎",
    totalClaimed: "總計領取金豆",
    welfareRulesTitle: "7天福利規則",
    welfareCondTitle: "1. 參與條件：",
    welfareCond1: "a. 自註冊起7天內的新用戶",
    welfareCond2: "b. 完成主播認證",
    welfareCond3: "c. 未加入公會",
    welfareRewardTitle: "2. 獎勵說明",
    welfareReward1: "a. 每日上麥並開麥可以累計時長。",
    welfareReward2: "b. 每1小時，可以領取5,000金豆。",
    welfareReward3: "c. 單日最高可領取2小時，10,000金豆。",
    welfareReward4: "d. 最多可領取70,000金豆獎勵。",
    welfareNoteTitle: "3. 注意事項。",
    welfareNote1: "a. 獎勵每日手動領取",
    welfareNote2: "b. 若註冊時間超過7日，則無法再次領取。",
    welfareNote3: "c. 數據每10-15分鐘更新",
    welfareNote4: "d. 若發現利用不公正的手段刷取獎勵，將會封號處理。",
    micRulesTitle: "上麥獎勵規則",
    micCondTitle: "1. 參與條件：",
    micCond1: "a. 完成主播認證",
    micCond2: "b. 未加入公會。",
    micRewardTitle: "2. 獎勵",
    micGradeLevel: "等級",
    micGradeIncome: "近7天收益金豆",
    micGradeHourly: "時薪 (金豆/h)",
    micGradeDaily: "單日上限",
    micGradeBeans: "{beans} 金豆 ({usd})",
    micGradeDailyLimit: "2 小時",
    micExplainTitle: "3. 說明",
    micExplain1:
      "a. RainChat會根據你的近7天金豆收益，進行等級核算（當前+前六天）",
    micExplain2: "b. 數據每10-15分鐘更新。",
    micExplain3: "c. 根據當前等級，可領取對應等級下的金豆時薪獎勵。",
    micExplain4: "d. 獎勵手動領取，領取後獎勵實時到賬。",
    micExplain5: "e. 若當天未領取，獎勵會過期。",
    micExplain6: "f. 單日可領取2小時時薪。",
    micExplain7:
      "g. 近七天金豆收益超SS上限時。每多70萬金豆收益，時薪核算多2萬。",
    micExplainExample: "例：7,700,000金豆，時薪220,000。",
    micExplain8:
      "h. 享受「7天福利」時，「等級I」時薪獎勵不可用。「7天福利」結束後可正常領取。",
    micExplain9: "i. 若發現利用不公正的手段刷取獎勵，將會封號處理。",
    nextRefresh: "下次刷新",
    recent7Days: "最近7日",
    micRangeTip: "今天+前6天\n需要成為主播",
    totalIncome: "總收入",
    upgradeDesc: "還差{remain}可升級，獎金增加{bonus}",
    ssBonusDesc: "每多700K金豆，獎金增加20K金豆",
    completeAllTask: "完成所有任務可獲得",
    claim: "領取",
    grantSuccess: "獎勵發放成功",
    thisTimeGot: "本次獲得",
    grantedToAccount: "獎勵已發放至您帳戶",
    gotIt: "明白了",
    claimFail: "領取失敗，請稍後重試",
    micTaskName: "今日開播/上麥{minutes}分鐘",
  },
  guildApply: {
    "title": "公會申請",
    "pendingCount": "{count}條待處理",
    "autoApproveTip": "超過7天未處理的申請將自動同意，請及時審核",
    "joinRequest": "（{rainId}）想加入公會",
    "daysRemaining": "剩餘{days}天",
    "appliedWithinOneDay": "一天內申請",
    "appliedDaysAgo": "{days}天前",
    "boundDays": "綁定天數：{days}天",
    "incomeTier": "收入等級：{level}",
    "applyToGuild": "申請公會",
    "reject": "拒絕",
    "approve": "同意",
    "noPendingRequests": "暫無待處理申請",
    "approved": "已同意申請",
    "rejected": "已拒絕申請",
    "approvalConfirmTitle": "提示",
    "approvalConfirmMessage": "同意後，對方將加入他人公會，並且不再為你提供收入分傭",
    "back": "返回",
    "pendingList": "待處理申請",
    "noToken": "未獲取到登入憑證",
    "listLoadFailed": "申請列表載入失敗",
    "listLoadFailedRetry": "申請列表載入失敗，請稍後重試",
    "operationFailedRetry": "操作失敗，請稍後重試"
  },
  inviteFriendsNew: {
    "inviteRanking": "邀請排行榜",
    "messages": "消息",
    "totalRewards": "邀請獎勵總計",
    "earnings": "收益",
    "totalValue": "總價值",
    "viewDetails": "查看明細",
    "inviteStats": "邀請統計",
    "totalInvites": "累計",
    "todayInvites": "今日",
    "details": "詳情",
    "inviteFriends": "邀請好友",
    "copyLink": "複製專屬連結",
    "close": "關閉彈窗",
    "saveImage": "儲存圖片",
    "inviteModal": "邀請好友彈窗",
    "rightTools": "頁面入口",
    "noToken": "未獲取到登入憑證",
    "rewardsLoadFailed": "邀請收益載入失敗",
    "rewardsLoadFailedRetry": "邀請收益載入失敗，請稍後重試",
    "inviteInfoLoadFailed": "邀請資訊載入失敗",
    "inviteInfoLoadFailedRetry": "邀請資訊載入失敗，請稍後重試",
    "linkNotReady": "邀請連結尚未載入完成",
    "linkCopied": "邀請連結已複製",
    "copyFailedRetry": "複製失敗，請稍後重試",
    "saveFailedRetry": "儲存圖片失敗，請稍後重試"
  },
  inviteRanking: {
    "title": "排行榜",
    "earningsRank": "收益排名",
    "inviteRank": "邀請排名",
    "day": "日",
    "week": "週",
    "total": "總",
    "people": "人",
    "noToken": "未獲取到登入憑證",
    "loadFailed": "排行榜載入失敗",
    "loadFailedRetry": "排行榜載入失敗，請稍後重試"
  },
  inviterInformation: {
    "title": "我的邀請",
    "earnings": "收益",
    "members": "人員",
    "filter": "篩選：",
    "earningsTrend": "收益趨勢",
    "dailyInvites": "每日邀請人數",
    "verifiedHost": "認證主播",
    "inGuild": "已入公會",
    "contact": "聯繫",
    "level1Earnings": "一級收益",
    "level2Earnings": "二級收益",
    "totalUsd": "總（USD）",
    "loading": "載入中...",
    "noMore": "沒有更多了",
    "noData": "暫無數據",
    "back": "返回",
    "tabTypes": "邀請人資訊類型",
    "dateFilter": "日期篩選",
    "noToken": "未獲取到登入憑證",
    "trendLoadFailed": "趨勢資料載入失敗",
    "trendLoadFailedRetry": "趨勢資料載入失敗，請稍後重試",
    "listLoadFailed": "邀請人列表載入失敗",
    "listLoadFailedRetry": "邀請人列表載入失敗，請稍後重試"
  },
  rewardSource: {
    "title": "獎勵明細",
    "pleaseSelect": "請選擇",
    "activityEarnings": "活躍",
    "rechargeEarnings": "充值",
    "gameCommission": "遊戲",
    "incomeCommission": "收入",
    "back": "返回"
  },
  rewardSourceRule: {
    "back": "返回",
    "active": {
      "title": "邀請活躍規則",
      "bindTitle": "如何綁定好友",
      "bindSteps": [
        "第一步：透過邀請活動主頁下方邀請按鈕，保存圖片or複製專屬連結。",
        "第二步：將保存好的圖片or專屬連結，發送給你的好友。",
        "第三步：好友透過圖片二維碼or專屬連結，下載並註冊，即可綁定好友。"
      ],
      "questionTitle": "Q：為什麼綁定不上？",
      "answer": "A：每一部手機只能有一個帳號綁定。可能你的朋友提前綁定過。",
      "userTitle": "活躍用戶規則",
      "userIntro": "你綁定的好友，透過完成每日活躍任務會為你增加活躍用戶數。",
      "tasks": [
        "任務1：上麥並開麥2小時。",
        "任務2：Game流水達到1,000金幣。",
        "必須完成認證。",
        "完成以上任意一個任務，即可為你提供一個活躍用戶數。",
        "每個好友1天只能提供1個有效用戶數。"
      ],
      "userNotes": [
        "每個綁定的好友，從註冊開始計算，只有前7天可以為你提供有效用戶數。",
        "每個綁定的好友至多只能為你提供7次有效用戶數。"
      ],
      "rewardTitle": "活躍用戶獎勵",
      "rewardIntro": "當你每天的有效用戶數達到一定數量時，可以獲得金豆獎勵。",
      "rewardTableIntro": "獎勵如下。",
      "rewardTableLabel": "活躍用戶金豆獎勵表",
      "rewardHeaders": ["每日活躍用戶數", "金豆獎勵", "價值＄"],
      "rewardNotes": [
        "單日最高可以獲得價值70美金的獎勵。",
        "當日的獎勵，將於次日10點開啟手動領取。",
        "領取位置：直播Tab or 直播間 懸浮按鈕“獎勵”內領取。",
        "獎勵發放後，需要當天領取，否則會過期，有獎勵請儘快領取。"
      ],
      "noticeTitle": "注意事項",
      "notices": [
        "每一部手機只可有一個綁定。",
        "綁定的好友必須要完成認證，才可以為你提供活躍用戶計數。",
        "列表中僅展示7天內註冊的用戶。",
        "若發現利用不正當手段綁定or刷取用戶數量，平台將不予獎勵發放；情節嚴重將封號等處理。"
      ]
    },
    "game": {
      "title": "遊戲分佣規則",
      "levelTitle": "遊戲分佣等級制度",
      "levelText": "你、一級成員、以及二級成員，三層團隊的總Game流水決定你的等級。流水越高，等級越高，收益越多。",
      "rewardTitle": "獎勵構成",
      "rewards": [
        "一級分佣：直接從一級成員的Game流水中獲得分成收益。",
        "二級分佣：若一級成員評級比你低，額外從二級成員處獲得收益"
      ],
      "tierTitle": "遊戲分佣等級表",
      "tierLabel": "遊戲分佣等級表",
      "tierHeaders": ["等級", "30天團隊總Game流水", "分成比例"],
      "tierNote": "你的等級將由你團隊的30天Game流水進行評定。",
      "assessmentTitle": "獎勵發放與等級評定規則",
      "assessments": [
        "每日0點，將會為你統計你團隊前30天的流水，為你評定等級。",
        "並根據你評定的等級為你結算前一天的獎勵。"
      ],
      "exampleTitle": "簡單示例",
      "examples": [
        "你的評級 Lv.5，一級成員產生的流水的 0.5% 會獎勵給你。",
        "你的評級 Lv.5，你的一位一級成員評級 Lv.3，那麼這位一級成員帶來的二級成員Game流水，將有 0.2% 獎勵給你。因為你們評級分成比例的差距為 0.2% (0.5% - 0.3%)。",
        "若你的評級 Lv.5，你的一位一級成員評級同樣是 Lv.5，那麼這位一級成員帶來的二級成員Game流水將不會給你提供獎勵，因為你們的差距為 0 (0.5% - 0.5%)。"
      ],
      "detailTitle": "詳細圖示說明",
      "detailTeamTitle": "團隊評級計算：",
      "detailTeams": [
        {
          "title": "A團隊評級",
          "lines": [
            "自身投注+一級用戶投注+二級用戶投注。",
            "A投注+B投注+C投注+D投注+E投注+F投注+G投注=10M+20M+10M+5M+800M+200M+10M=1055M",
            "評級為Lv.5，分佣率0.5%。"
          ]
        },
        {
          "title": "B團隊（A的一級成員）",
          "lines": [
            "B投注+E投注+F投注=20M+800M+200M=1020M",
            "評級為Lv.5,分佣率0.5%。"
          ]
        },
        {
          "title": "C團隊（A的一級成員）",
          "lines": [
            "C投注+G投注=20M。",
            "評級為Lv.2，分佣率0.2%。"
          ]
        }
      ],
      "detailIncomeTitle": "用戶 A 收益情況：",
      "detailIncomeGroups": [
        {
          "title": "A 從一級用戶 (B, C, D) 獲得的直接返利 ：(B自身投注 + C自身投注 + D自身投注) × A的返利比例 = (20M + 10M + 5M) × 0.5% = 35M × 0.5% = 175,000 金幣 (折合$17.50 美元)。"
        },
        {
          "title": "A 從二級用戶 (E, F, G) 獲得的極差返利 ：",
          "lines": [
            "來自 E, F：(A分佣率-B分佣率) × (E+F) = (0.5%-0.5%) × (800M+200M) = $0 美元（B的分佣率與A的分佣率一致，極差為0，所以沒有任何獎勵）。",
            "來自 G：(A分佣比例-C分佣比例) × G = (0.5%-0.2%) × 10M = 0.3% × 10M = 30,000 金幣 (折合 $3.00 美元)  （A的分佣率比C的分佣率多0.3%，所以會獲得G的0.3%的獎勵）。"
          ]
        }
      ]
    },
    "income": {
      "title": "收入分佣規則",
      "levelTitle": "收入分佣等級制度",
      "levelText": "你、一級成員、以及二級成員，三層團隊的總收入決定你的等級。團隊收入越高，等級越高，收益越多",
      "rewardTitle": "獎勵構成",
      "rewards": [
        "自身收入",
        "一級成員的收入",
        "二級成員的收入"
      ],
      "tierTitle": "收入分佣等級表",
      "tierLabel": "收入分佣等級表",
      "tierHeaders": ["等級", "團隊近30天金豆收入", "分佣率"],
      "tierNote": "你的等級，將由你團隊的近30天總收入評定等級。",
      "sPlusTierText": "獲得2組S級1級成員",
      "sPlusTitle": "S+",
      "sPlus": [
        "若你的團隊中，有兩名一級成員達到S級，你將會升級為S+。",
        "將會擁有21%的分佣率"
      ],
      "assessmentTitle": "獎勵發放與等級評定規則",
      "assessments": [
        "每日0點，將會為你統計你團隊前30天的流水，為你評定等級。",
        "並根據你評定的等級為你結算前一天的獎勵。"
      ],
      "exampleTitle": "簡單示例",
      "examples": [
        "示例1：你的等級是 S，你的任何禮物收入，你都會獲得 20% 的金豆獎勵。",
        "示例2：你的等級是 S，你的一級成員是 A。那麼你會獲得這位一級成員，以及他帶來的二級成員禮物收入的 2% 金豆獎勵。因為你們的等級差距是 20% - 18% = 2%。",
        "示例3：你的等級是 S，你有一位一級成員也是 S。那麼你將無法從這位一級成員處獲得收益。",
        "示例4：如果你有兩位一級成員是 S，那麼你將成為 S+，分佣率達到 21%，仍然可以獲得他們的收入的 1% 獎勵。"
      ],
      "noticeTitle": "注意事項",
      "notices": [
        "若你團隊中的某位成員加入了公會，那麼他將不再為你提供收入分佣，但會為你統計團隊收入，計算你的分佣等級。",
        "等級根據最近30天的團隊禮物收入金豆收益判斷。",
        "必須認證為主播，才可以計算收益。"
      ],
      "detailTitle": "詳細圖示說明",
      "detailGroups": [
        {
          "title": "團隊評級計算",
          "items": [
            {
              "title": "A團隊評級：",
              "points": [
                { "title": "A收入+B收入+C收入+D收入+E收入+F收入=20M+156M+98M+40M+4M+2M=320M", "lines": [] },
                { "title": "評級S，分佣率20%", "lines": [] }
              ]
            },
            {
              "title": "B團隊評級：",
              "points": [
                { "title": "B收入+D收入+E收入=156M+40M+4M=200M", "lines": [] },
                { "title": "評級A，分佣率18%", "lines": [] }
              ]
            },
            {
              "title": "C團隊評級：",
              "points": [
                { "title": "C收入+F收入=98M+2M=100M", "lines": [] },
                { "title": "評級A，分佣率18%", "lines": [] }
              ]
            }
          ]
        },
        {
          "title": "A收入計算",
          "items": [
            {
              "title": "自身收入",
              "points": [
                { "title": "A收益×A評級=20M×20%=4,000,000金豆", "lines": [] }
              ]
            },
            {
              "title": "一級成員收入",
              "points": [
                { "title": "成員B", "lines": ["B收入×（A分佣率-B分佣率）=156M×（20%-18%）=3,120,000金豆"] },
                { "title": "成員C", "lines": ["C收入×（A分佣率-B分佣率）=98M×（20%-18%）=1,960,000金豆"] }
              ]
            },
            {
              "title": "二級成員收入",
              "points": [
                { "title": "成員D、E（B的成員）", "lines": ["（D收入+E收入）×（A分佣率-B分佣率）=（40M+4M）×（20%-18%）=880,000金豆"] },
                { "title": "成員F（C的成員）", "lines": ["F收入×（A分佣率-B分佣率）=2M×（20%-18%）=40,000金豆"] }
              ]
            },
            {
              "title": "總計",
              "points": [
                { "title": "自身額外收入：4M金豆", "lines": [] },
                { "title": "邀請極差收入：3.12M+1.96M+0.88M+0.04M=6M", "lines": [] },
                { "title": "總計收入10M金豆。", "lines": [] }
              ]
            }
          ]
        }
      ]
    },
    "recharge": {
      "title": "充值獎勵規則",
      "cashbackTitle": "充值返利",
      "cashback": [
        "自你的好友註冊30天起，他的充值將為你提供充值返利。",
        "你的好友邀請的好友，自註冊30天起，也將會為你提供充值返利。"
      ],
      "chainTitle": "關係鏈",
      "chainIntro": "如圖：A邀請B，B邀請C，C邀請D。",
      "chainAlt": "A、B、C、D邀請關係鏈示意圖",
      "chainExamples": [
        "B充值10,000金幣。A將會獲得200金幣（2%返利）。",
        "C充值10,000金幣。B將會獲得200金幣（2%返利），A將會獲得100金幣（1%返利）。",
        "D充值10,000金幣。C將會獲得200金幣（2%返利），B將會獲得100金幣（1%返利），A將不再獲得來自D的返利。",
        "一級直推將會為你提供2%的返利。",
        "二級間推將會為你提供1%的返利。"
      ],
      "validityTitle": "30天有效期",
      "validity": [
        "自被邀請好友註冊起30日的所有充值，都將會為他的上級提供返利。",
        "超過30天後，產生的充值，將不再提供任何返利。"
      ],
      "payoutTitle": "獎勵發放規則",
      "payout": [
        "用戶完成充值後，獎勵將會實時發放至你的錢包內。",
        "充值方式包括：金幣直充、代理充值。"
      ]
    }
  },
  rewardSourceDetail: {
    "title": "獎勵來源明細",
    "rules": "規則",
    "activityEarnings": "活躍",
    "rechargeEarnings": "充值",
    "gameCommission": "遊戲",
    "incomeCommission": "收入",
    "totalEarnings": "總計",
    "yesterdayEarnings": "昨日",
    "todayEstimate": "今日",
    "todayActiveUsers": "有效用戶",
    "currentRankReward": "當前獎勵",
    "upgradeReward": "再活躍{count}，獎勵升級{reward}",
    "maxRewardTier": "已達最高獎勵檔位",
    "teamRevenue": "30天團隊總流水",
    "currentCommission": "當前分佣",
    "upgradeCommission": "需要{flow}流水，升級至{rate}",
    "maxCommissionTier": "已達最高分傭檔位",
    "invitedUsers": "近7天邀請用戶",
    "all": "全部",
    "active": "活躍",
    "inactive": "未活躍",
    "certified": "已認證",
    "agency": "Agency",
    "micTime": "上麥時長",
    "minutes": "分鐘",
    "gameRevenue": "遊戲流水",
    "coins": "金幣",
    "loading": "載入中...",
    "noMore": "沒有更多了",
    "noData": "暫無數據",
    "total": "總計",
    "last7Days": "近7天",
    "yesterday": "昨日",
    "today": "今日",
    "level1Commission": "一級分佣",
    "level2Commission": "二級分佣",
    "totalIncome": "總收入",
    "commissionRate": "分傭比例",
    "upgradeGap": "距升級差{amount}",
    "activeHelpUpdate": "10-15 分鐘更新資料",
    "activeHelpReward": "獎勵於次日 10 點，在「首頁-獎勵」頁面處領取",
    "rechargeHelpUpdate": "10-15 分鐘更新資料",
    "rechargeHelpReward": "用戶充值後，獎勵立即到賬",
    "gameHelpUpdate": "10-15 分鐘更新資料",
    "gameHelpReward": "獎勵次日系統發放",
    "roomHelpUpdate": "10-15 分鐘更新資料",
    "roomHelpCommission": "包含：你的、一級成員、二級成員的收入分傭",
    "roomHelpReward": "獎勵次日系統發放",
    "back": "返回",
    "viewHelp": "查看說明",
    "todayEstimateHelp": "今日預估說明"
  },
};
